import { render } from "./_wp_editor.vue?vue&type=template&id=0b1f8eb6"
import script from "./_wp_editor.vue?vue&type=script&lang=js"
export * from "./_wp_editor.vue?vue&type=script&lang=js"

import "./_wp_editor.vue?vue&type=style&index=0&id=0b1f8eb6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Pieces/_wp_editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b1f8eb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b1f8eb6', __exports__)) {
    api.reload('0b1f8eb6', __exports__)
  }
  
  module.hot.accept("./_wp_editor.vue?vue&type=template&id=0b1f8eb6", () => {
    api.rerender('0b1f8eb6', render)
  })

}


export default __exports__